module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAABHNCSVQICAgIfAhkiAAAAONJREFUKFOVkkERwkAMRV8UgAOQgAQ40HNRAHWAFBzQKoBzOYAEJICDVkGY37JMpkOHIafd7P/J/p8YIS6wdNga5MAUaBzOBtUabglq6VBDabCNReLZocygUK4j/SIkciKavgRc3w+tw97gAEyA4V2wlcUuDkUGZQ0Lg7NDnsG9hp3BUQyHSp2ad1XlJHwlYNCqAvqJjOkwIvlA/HMN85S7wAOYRcywkzQsv3SS3dKoaEc1ASdgM6YputcY7L13rxvu4N679+ecqqx3so9fA5bVInw2Ijil3VMl7V4arnavjLv3Aq0dV8dntM0xAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/times-circle-red.png
// module id = CxtS
// module chunks = 2